import { FirstPage } from './components/first-page'

export const SectionTen = () => {
  return <FirstPage />
}
